import { Injectable } from '@angular/core';
import { MenuConfig } from '../classes/MenuConfig'
import { Http, RequestOptions, Headers } from '@angular/http';
import { Adal4Service } from "adal-angular4";

@Injectable()
export class PermissionService {

  token: string;
  private headers = new Headers({'content-Type': 'application/json'});;
  constructor(private http: Http, private AdalService: Adal4Service) {
    this.token = this.AdalService.userInfo.token;     
    this.headers.append('authorization',`bearer ${this.token}`)
   }

  getPermissionLevel(email: string) : Promise<number>{
   
    return this.http.get(`/api/Access/${email}`, { headers: this.headers })
    .toPromise()
    .then(pl => pl.json() as number)
    .catch();
  }

  getMenuItens(roles: Array<string>) : Promise<MenuConfig[]>{
    let menuItens: MenuConfig[] = [];

    let menuItem1 = new MenuConfig("/consultardados","Consultar Dados", null);

    let subItemsRelatorios : MenuConfig[] = [];
    let menuItem2_1 = new MenuConfig("/novorelatorio","Criar Relatório", null);
    let menuItem2_2 = new MenuConfig("/gerenciarrelatorios","Editar/Excluir Relatórios", null)
    let menuItem2_3 = new MenuConfig("/gerenciarconexoes","Gerenciar Conexões", null)
    subItemsRelatorios.push(menuItem2_1, menuItem2_2, menuItem2_3);

    let menuItem2 = new MenuConfig("","Gerenciar Relatórios", subItemsRelatorios);

    let subItemsAdministracao : MenuConfig[] = []; 
    let menuItem3_1 = new MenuConfig("/gerenciarusuarios","Usuários", null);
    //let menuItem3_2 = new MenuConfig("/gerenciargrupos","Gerenciar Grupos", null);
    let menuItem3_3 = new MenuConfig("/auditoria","Auditoria", null);
    subItemsAdministracao.push(menuItem3_1, menuItem3_3);
    
    let menuItem3 = new MenuConfig("","Administração", subItemsAdministracao);

    if (roles.includes("Administradores")){
      menuItens.push(menuItem3)
    }

    if (roles.includes("CadastroRelatorios")){
      menuItens.push(menuItem2, menuItem1)
    }

    if(roles.join().toLowerCase().indexOf("consulta") > -1){
      if(!menuItens.includes(menuItem1)){
        menuItens.push(menuItem1)
      }
    }

    // switch (permissionLevel) {
    //   case 1:        
    //     menuItens = [menuItem1];
    //     break;
    //   case 2:
    //     menuItens = [menuItem2, menuItem1];
    //     break;
    //   case 3:{
    //     menuItens = [menuItem3]//, menuItem2, menuItem1];
    //     break;
    //   }
    //   default:
    //     break;      
    // }
        return Promise.resolve(menuItens);
  }

  cleanCacheBeforeLogout() : Promise<boolean>{
    return this.http.get(`/api/logout`, { headers: this.headers })
    .toPromise()
    .then(cleanedOut => cleanedOut.json() as boolean)
    .catch();
  }
}





// WEBPACK FOOTER //
// C:/Users/ewerton.w.da.silva/Documents/Visual Studio 2017/Projects/SCL_Valia/SCL_Valia/src/app/shared/services/permission.service.ts